// apps/web/src/pages/vendas/detalhe/alerta-conflito-pv.tsx — Fase 12, Plano 31 (PV-07, T-12-49).
// Alerta comum dos Sheets e diálogos de ajuste: conflito de versão (lock otimista) NÃO apaga o que o usuário
// digitou; ele continua na tela até clicar em "Recarregar PV".
import { AlertTriangle, Loader2 } from 'lucide-react';
import { Alert, AlertDescription } from '../../../components/ui/alert';
import { Button } from '../../../components/ui/button';

interface AlertaConflitoPvProps {
  readonly mensagem: string;
  readonly onRecarregar: () => void;
  readonly recarregando: boolean;
}

export function AlertaConflitoPv({ mensagem, onRecarregar, recarregando }: AlertaConflitoPvProps) {
  return (
    <Alert className="border-amber-300 bg-amber-50 text-amber-900">
      <AlertTriangle aria-hidden="true" />
      <AlertDescription className="text-amber-900">
        <p className="font-semibold">{mensagem}</p>
        <p>O que você digitou continua aqui até você recarregar.</p>
        <div className="mt-2">
          <Button type="button" size="sm" variant="outline" onClick={onRecarregar} disabled={recarregando}>
            {recarregando && <Loader2 className="animate-spin" aria-hidden="true" />}
            Recarregar PV
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
